
export const MenuTheme = {
    MenuGroup: {
        baseStyle: {
            p: "0",
            _title: {
                p: "3"
            }
        }
    }
}